export default __webpack_public_path__ + "static/media/ff_en_3.ff82a400.png";